module.exports = __webpack_public_path__ + "media/application/images/flags/fr-16-2553a017051e00977fff20a4b490b316.png";